const PLUS_CODE_PATTERN = /^[A-Z0-9]{2,}\+[A-Z0-9]+/i;

export function pickComponent(
  components: google.maps.GeocoderAddressComponent[] | undefined,
  type: string,
): string | undefined {
  return components?.find((c) => c.types.includes(type))?.long_name;
}

export function composeStreetFromComponents(
  components: google.maps.GeocoderAddressComponent[] | undefined,
): string {
  if (!components?.length) return '';

  const route = pickComponent(components, 'route');
  const streetNumber = pickComponent(components, 'street_number');
  if (route) {
    const candidate = streetNumber ? `${route} ${streetNumber}` : route;
    if (!PLUS_CODE_PATTERN.test(candidate)) return candidate;
  }

  const streetAddress = pickComponent(components, 'street_address');
  if (streetAddress && !PLUS_CODE_PATTERN.test(streetAddress)) {
    return streetAddress;
  }

  const premise = pickComponent(components, 'premise');
  if (premise) {
    const subpremise = pickComponent(components, 'subpremise');
    const candidate = subpremise ? `${subpremise}, ${premise}` : premise;
    if (!PLUS_CODE_PATTERN.test(candidate)) return candidate;
  }

  const intersection = pickComponent(components, 'intersection');
  if (intersection && !PLUS_CODE_PATTERN.test(intersection)) {
    return intersection;
  }

  return '';
}
